<div class="w-6 h-6 flex items-center justify-center relative">
    <img src="/assets/svg-icons/status-ok.svg" class="absolute transition-opacity w-4 h-4" [class.opacity-0]="status !== 'ok'" alt="OK">
    <img src="/assets/svg-icons/status-wip.svg" class="absolute transition-opacity w-4 h-4" [class.opacity-0]="status !== 'wip'" alt="WIP">
    <img src="/assets/svg-icons/status-intolerant.svg" class="absolute transition-opacity w-4 h-4" [class.opacity-0]="status !== 'intolerant'" alt="INTOLERANT">
</div>
